import { render } from "./MessageForwarder.vue?vue&type=template&id=4ff4547b"
import script from "./MessageForwarder.vue?vue&type=script&lang=js"
export * from "./MessageForwarder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__